import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { FunctionComponent } from "react";
import { UserApi } from "../../../redux/api/UserApi";
import {Label} from "@progress/kendo-react-labels";
import { DropDownList } from "@progress/kendo-react-dropdowns";

const TeamList: FunctionComponent<FieldRenderProps> = props => {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        disabled,
        hint,
        type,
        optional,
        value,
        teamId,
        data,
        selectedPriority,
        priorityChangeHandler,
        showHint,
        ...others
      } = props;
      const { data: teams } = UserApi.useGetTeamsQuery();
      const selectedTeam = teams?.filter(f=>f.ID === teamId);
      const allTeams = {ID:undefined,Dept_Name: `All ${label}s` }
    return(
        <FieldWrapper>
            <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label} 
            </Label>            
            <div className={"k-form-field-wrap"}>    
                <DropDownList defaultItem={allTeams} value={selectedTeam?.length > 0 ? selectedTeam[0] : undefined} data={teams} dataItemKey="ID" textField="Dept_Name" popupSettings={{className:'z500' }} {...others} />
                
            </div>
            </FieldWrapper>
    )
}

export default TeamList;